<template>
  <div class="index-view" v-loading="loading" :style="{ '--height': height, }">
    <div class="index-view-top">
      <div class="logo"><img src="../assets/768.png" alt=""></div>
      <div class="money">
        <div @click="getTronweb">
          <p>
            {{
                walletName
                  ? walletName.slice(0, 5) +
                  "..." +
                  walletName.slice(walletName.length - 4, walletName.length)
                  : $t("luckyhash.walletName")
            }}
          </p>
        </div>
        <div @click="show = true">
          <img v-if="languageType == 'Chinese'" src="../assets/200.png" />
          <img v-if="languageType == 'English'" src="../assets/201.png" />
          <img v-if="languageType == 'Traditional'" src="../assets/200.png" />
          <img v-if="languageType == 'Japanese'" src="../assets/203.png" />
          <img v-if="languageType == 'Vietnamese'" src="../assets/204.png" />
          <img v-if="languageType == 'Malay'" src="../assets/205.png" />
          <img v-if="languageType == 'Hindi'" src="../assets/206.png" />
          <img v-if="languageType == 'Thai'" src="../assets/207.png" />
          <img v-if="languageType == 'Russian'" src="../assets/208.png" />
          <img v-if="languageType == 'Indonesian'" src="../assets/209.png" />
        </div>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div @click="changeLanguageType('Chinese')">简体中文</div>
          <div @click="changeLanguageType('English')">English</div>
          <div @click="changeLanguageType('Traditional')">繁體中文</div>
          <div @click="changeLanguageType('Japanese')">日本語</div>
          <div @click="changeLanguageType('Vietnamese')">Tiếng Việt</div>
          <div @click="changeLanguageType('Malay')">Malaysia</div>
          <div @click="changeLanguageType('Hindi')">हिंदीName</div>
          <div @click="changeLanguageType('Thai')">ภาษาไทย</div>
          <div @click="changeLanguageType('Russian')">Русский</div>
          <div @click="changeLanguageType('Indonesian')">bahasa Indonesia</div>
        </div>
        <div />
      </div>
    </van-overlay>
    <div class="user-scroll">
      <div class="banner">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in bannerLists" :key="index">
            <img :src="baseUrl + item.img" alt="" @click="toLink(item)" style="width: 100%; height: 150px" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="advertisement" @click="tonotice">
        <van-notice-bar mode="link" :scrollable="false" background="#000" color="#999999" left-icon="volume-o"
          :text="informationlist" />
      </div>
      <div class="exchange">
        <div class="exchange-div">
          <!-- <div @click="toExchange">
            <div><img src="../assets/image/dh.png" /></div>
            <div><span>{{ $t("luckyhash.exchange") }}</span></div>
          </div> -->
          <div @click="toBalance()">
            <div><img src="../assets/cz.png" /></div>
            <div class="span"><span>{{ $t("user.top_up") }}</span></div>
          </div>
          <div @click="withdrawal(0)">
            <div><img src="../assets/qb.png" /></div>
            <div class="span"><span>{{ $t("user.withdrawal") }}</span></div>
          </div>
          <div @click="$router.push('/vip')">
            <div><img src="../assets/image/jl.png" /></div>
            <div class="span"><span>{{ $t("luckyhash.reward") }}</span></div>
          </div>
          <!-- <div @click="contactInfo">
            <div><img src="../assets/image/kf.png" /></div>
            <div class="span"><span>{{ $t("luckyhash.Customerservice") }}</span></div>
          </div> -->
          <div @click="question">
            <div><img src="../assets/image/sm.png" /></div>
            <div class="span"><span>{{ $t("luckyhash.instructions") }}</span></div>
          </div>
        </div>
      </div>
      <div class="lucky">
        <div :class="lucky == 1 ? 'click-div' : ''" @click="lucky = 1">
          <span>{{ $t("luckyhash.luckyhash") }}</span>
        </div>
        <div :class="lucky == 2 ? 'click-div' : ''" @click="lucky = 2">
          <span>{{ $t("luckyhash.entertainment") }}</span>
        </div>
      </div>
      <div class="lucky-item-match" v-if="lucky == '1'">
        <div>
          <!-- 分割线 -->
          <div class="padding">
            <div class="big big-back4" :style="{ backgroundImage: `url(${baseUrl + coverlLists.B1})` }">
              <div>
                <p>{{ $t("luckyhash.Doublesided") }}</p>
              </div>
              <div @click="toMatchDetails({ type: 'B1', name: $t('luckyhash.Doublesided') })">
                <p>{{ $t("luckyhash.immediately") }}</p>
              </div>
            </div>
            <div class="big big-back5" :style="{ backgroundImage: `url(${baseUrl + coverlLists.B2})` }">
              <div>
                <p>{{ $t('luckyhash.combination') }}</p>
              </div>
              <div @click="toMatchDetails({ type: 'B2', name: $t('luckyhash.combination') })">
                <p>{{ $t("luckyhash.immediately") }}</p>
              </div>
            </div>
            <div class="big big-back4" :style="{ backgroundImage: `url(${baseUrl + coverlLists.B3})` }">
              <div>
                <p>{{ $t('luckyhash.LongHuge') }}</p>
              </div>
              <div @click="toMatchDetails({ type: 'B3', name: $t('luckyhash.LongHuge') })">
                <p>{{ $t("luckyhash.immediately") }}</p>
              </div>
            </div>
            <div class="big big-back5" :style="{ backgroundImage: `url(${baseUrl + coverlLists.B4})` }">
              <div>
                <p>{{ $t('luckyhash.baccarat') }}</p>
              </div>
              <div @click="toMatchDetails({ type: 'B4', name: $t('luckyhash.baccarat') })">
                <p>{{ $t("luckyhash.immediately") }}</p>
              </div>
            </div>
            <div class="big big-back3" style="width:100%;"
              :style="{ backgroundImage: `url(${baseUrl + coverlLists.B5})` }">
              <div>
                <p>{{ $t('luckyhash.gallbladder') }}</p>
              </div>
              <div @click="toMatchDetails({ type: 'B5', name: $t('luckyhash.gallbladder') })">
                <p>{{ $t("luckyhash.immediately") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="lucky == 2">
        <div class="padding-two">
          <div class="big big-back2" style="width:100%"
            :style="{ backgroundImage: `url(${baseUrl + coverlLists.A1})` }">
            <div>
              <p>{{ $t("luckyhash.Hashracingcar") }}</p>
            </div>
            <div @click="toEntertainment({ type: 'A1', name: $t('luckyhash.Hashracingcar') })">
              <p>{{ $t("luckyhash.immediately") }}</p>
            </div>
          </div>
          <div class="big big-back3" :style="{ backgroundImage: `url(${baseUrl + coverlLists.A2})` }">
            <div>
              <p>{{ $t("luckyhash.Hashspeedboat") }}</p>
            </div>
            <div @click="toEntertainment({ type: 'A2', name: $t('luckyhash.Hashspeedboat') })">
              <p>{{ $t("luckyhash.immediately") }}</p>
            </div>
          </div>
          <div class="big big-back5" :style="{ backgroundImage: `url(${baseUrl + coverlLists.A3})` }">
            <div>
              <p>{{ $t("luckyhash.Hashracing") }}</p>
            </div>
            <div @click="toEntertainment({ type: 'A3', name: $t('luckyhash.Hashracing') })">
              <p>{{ $t("luckyhash.immediately") }}</p>
            </div>
          </div>
          <div class="big big-back3" style="width:100%"
            :style="{ backgroundImage: `url(${baseUrl + coverlLists.A4})` }">
            <div>
              <p>{{ $t("luckyhash.Doublesided") }}</p>
            </div>
            <div @click="toEntertainment({ type: 'A4', name: $t('luckyhash.Doublesided') })">
              <p>{{ $t("luckyhash.immediately") }}</p>
            </div>
          </div>
          <div class="big big-back4" :style="{ backgroundImage: `url(${baseUrl + coverlLists.A5})` }">
            <div>
              <p>{{ $t("luckyhash.combination") }}</p>
            </div>
            <div @click="toEntertainment({ type: 'A5', name: $t('luckyhash.combination') })">
              <p>{{ $t("luckyhash.immediately") }}</p>
            </div>
          </div>
          <div class="big big-back4" :style="{ backgroundImage: `url(${baseUrl + coverlLists.A6})` }">
            <div>
              <p>{{ $t("luckyhash.LongHuge") }}</p>
            </div>
            <div @click="toEntertainment({ type: 'A6', name: $t('luckyhash.LongHuge') })">
              <p>{{ $t("luckyhash.immediately") }}</p>
            </div>
          </div>
          <div class="big big-back4" :style="{ backgroundImage: `url(${baseUrl + coverlLists.A7})` }">
            <div>
              <p>{{ $t("luckyhash.baccarat") }}</p>
            </div>
            <div @click="toEntertainment({ type: 'A7', name: $t('luckyhash.baccarat') })">
              <p>{{ $t("luckyhash.immediately") }}</p>
            </div>
          </div>
          <div class="big big-back1" :style="{ backgroundImage: `url(${baseUrl + coverlLists.A8})` }">
            <div>
              <p>{{ $t("luckyhash.gallbladder") }}</p>
            </div>
            <div @click="toEntertainment({ type: 'A8', name: $t('luckyhash.gallbladder') })">
              <p>{{ $t("luckyhash.immediately") }}</p>
            </div>
          </div>
        </div>
      </div>
      <help @toFriend="toFriend" @toGuide="toGuide"></help>
      <div class="friend">
        <span>{{ $t("luckyhash.friend") }}</span>
      </div>
      <div class="TokenPocket">
        <div @click="toFriend('https://www.token.im/')">
          <img src="../assets/211.png" />
        </div>
        <div @click="toFriend('https://www.trustwallet.com/')">
          <img src="../assets/212.png" />
        </div>
        <div @click="toFriend('https://www.tronlink.org/')">
          <img src="../assets/213.png" />
        </div>
        <div @click="toFriend('https://www.ownbit.io/')">
          <img src="../assets/214.png" />
        </div>
        <div @click="toFriend('https://www.bitpie.com/')">
          <img src="../assets/215.png" />
        </div>
        <div @click="toFriend('https://www.huobiwallet.com/')">
          <img src="../assets/216.png" />
        </div>
      </div>
    </div>
    <van-popup v-model="announcementShow" round>
      <div class="container">
        <h2>{{ $t('announcement.title') }}</h2>
        <div class="content" style="padding:0 1rem">
          <div v-if="announcementList" v-html="announcementList" style="color:#ffffff;text-align: center;"></div>
        </div>
        <div class="close" @click="announcementShow = false">{{ $t('announcement.close') }}</div>
      </div>
    </van-popup>
    <tabbar class="footer-tabbar" :tabbarType="'1'" @changeActiveStatus="changeActiveStatus"></tabbar>
  </div>
</template>

<script>
import tabbar from '../components/tabbar'
import help from '../components/help'
import { problemList, contact, carousel, information, info, myWallet, informationTop } from '@/utils/request'
import { BASEURL } from '@/utils/http'
export default {
  components: {
    tabbar,
    help
  },
  inject: ['reload'],
  data() {
    return {
      announcementList: [],
      announcementShow: true,
      userName: '', //用户名
      loading: false,
      walletInfo: '', //钱包余额
      userInfo: '', //用户信息，用于校检是否设置交易密码
      loading: false,
      lucky: '1',
      show: false,
      walletName: '',
      baseUrl: '',
      bannerLists: '',
      coverlLists: {},
      problemList: [],
      bannerlist: [],
      informationlist: '',
      height: '', //屏幕高度
      allTimer: '',
      languageLists: '', //语言切换列表
      languageType: '', //当前语言
      walletLists: ''
    }
  },
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  //获取屏幕高度
  async beforeMount() {
    this.languageType = (await localStorage.getItem('language')) || 'Chinese'
    this.languageLists = this.$t('lang.langlist')

  },
  mounted() {
    this.baseUrl = BASEURL
    if (this.$store.state.walletName) {
      this.walletName = this.$store.state.walletName
    }
    this.getCarousel()
    this.getCoverl()
    this.problem()
    this.information()
  },
  destroyed() {
  },
  methods: {
    //合作伙伴
    toFriend(item) {
      window.open(item, '_blank')
    },
    toGuide(item) {
      this.$router.push({
        path: '/guide',
        query: {
          type: item
        }
      })
    },
    changeLanguageType(item) {
      let _this = this
      _this.languageType = item
      localStorage.setItem('language', item)
      _this.loading = true
      _this.show = false
      setTimeout(() => {
        _this.$i18n.locale = item
        _this.languageType = localStorage.getItem('language') || 'Chinese'
        _this.languageLists = this.$t('lang.langlist')
        _this.reload()
        _this.information()
        _this.getCarousel()
        _this.loading = false
      }, 1000)
    },
    toBalance() {
      if (!localStorage.getItem('token')) {
        this.$router.push('/index')
        return
      }
      this.$router.push('/recharge')
    },
    withdrawal(name) {
      if (!localStorage.getItem('token')) {
        this.$router.push('/index')
        return
      }
      if (this.walletLists.length > 0) {
        if (this.userInfo.payPwdStatus == '1') {
          this.$router.push('/withdrawal?name=' + name)
        } else {
          this.$router.push('/asset')
        }
      } else {
        this.$router.push('/add_address')

      }
    },
    toSpread() {
      if (!localStorage.getItem('token')) {
        this.$router.push('/index')
        return
      }
      this.$router.push('/spread')
    },
    //跳转到对应投注的详情页
    toMatchDetails(item) {
      this.$router.push({
        path: '/details',
        query: item
      })
    },
    //说明
    question() {
      this.$router.push('/question')
    },
    tonotice() {
      if (!localStorage.getItem('token')) {
        this.$router.push('/index')
        return
      }
      this.$router.push('/notice')
    },
    //常见问题详情页
    toNoticeDetails(item) {
      this.$router.push('/noticeDetails?item=' + JSON.stringify(item))
    },
    //跳转到兑换页面
    toExchange() {
      if (!localStorage.getItem('token')) {
        this.$router.push('/index')
        return
      }
      this.$router.push('/exchangeRecord')
    },
    //轮播图点击跳转
    toLink(item) {
      window.open(item.link, '_blank')
    },
    //客服跳转
    contactInfo() {
      contact().then(res => {
        if (res.code == '200') {
          window.open(res.data.url, '_blank')
        }
      })
    },
    //哈希娱乐城
    toEntertainment(item) {
      this.$router.push({
        path: '/entertainment',
        query: item
      })
    },
    changeActiveStatus(item) {
      if (item == '1') {
      } else if (item == '2') {
        this.$router.push('/vip')
        // this.$toast(this.$t('transactiondetails.noopen'))
      } else if (item == '3') {
        this.$router.push('/spread')
      } else if (item == '4') {
        this.$router.push('/help')
      } else if (item == '5') {
        if (!localStorage.getItem('token')) {
          this.$router.push('/index')
          return
        }
        this.$router.push('/user')
      }
    },

    information() {
      var that = this
      information({
        current: '1',
        size: '1'
      }).then(res => {
        if (res.code == '200') {
          that.informationlist = res.data.records[0].title
        }
      })
      informationTop().then(res => {
        if (res.code == '200') {
          let content = res.data.content.replace(RegExp('<img src="', 'g'), '<img style="max-width:100%;max-height:100%" src="' + this.baseUrl)
          this.announcementList = content
          console.log(this.announcementList)
        }
      })
    },
    problem() {
      var that = this
      problemList({
        current: '1',
        size: '3'
      }).then(res => {
        if (res.code == '200') {
          that.problemList = res.data.records
        }
      })
    },
    getCarousel() {
      carousel({ type: '1' }).then(res => {
        if (res.code == '200') {
          this.bannerLists = res.data
        }
      })
    },
    getCoverl() {
      carousel({ type: '3' }).then(res => {
        if (res.code == '200') {
          this.coverlLists = {}
          res.data.forEach(i => {
            this.coverlLists[i.title] = i.img
          })
        }
      })
    },
    //获取钱包地址并连接
    getTronweb() {
      const TronWeb = require('tronweb')
      const HttpProvider = TronWeb.providers.HttpProvider
      const fullNode = new HttpProvider('https://api.trongrid.io') //Your local TVM URL
      const solidityNode = new HttpProvider('https://api.trongrid.io')
      const eventServer = 'https://api.trongrid.io'
      const privateKey = '6d8d7cdc92dbcbe945643efe1a9fcd80d875ea82fbee3460ee0207611d12e1e9'
      const tronWeb = new TronWeb(fullNode, solidityNode, eventServer, privateKey)
      if (window.tronWeb) {
      } else {
        this.$toast(this.$t('phone.dk'))
      }
      var obj = setInterval(async () => {
        if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
          clearInterval(obj)
          this.$store.commit('changeWalletName', window.tronWeb.defaultAddress.base58)
          this.walletName = this.$store.state.walletName
        }
      }, 10)
    }
  }
}
</script>
<style lang="scss" scoped>
.van-popup {
  background-color: #161414;
}

.content {
  /deep/ #text {
    display: block;
    color: red;
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 21.5625rem;

  h2 {
    margin: 0.9375rem 0;
    font-size: 1rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #ffffff;
  }

  .close {
    width: 18.4375rem;
    height: 2.8125rem;
    margin: 2rem 0;
    background: #ffc400;
    border-radius: 1.4375rem;
    font-size: 1rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #0c0b0b;
    line-height: 2.8125rem;
    text-align: center;
  }
}

.notice-item {
  margin: 0 15px;
  padding: 0.9375rem;
  background: #161414;
  border-radius: 0.625rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.9375rem;

  .left {
    display: block;
    height: 1.625rem;
    width: 1.625rem;
    min-width: 1.625rem;
    background-image: url('../assets/xx.png');
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;

    >p {
      font-size: 0.6875rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }

  .right {
    padding-left: 0.625rem;

    >div:nth-child(1) {
      font-size: 0.875rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      padding-bottom: 0.3125rem;
    }

    >div:nth-child(2) {
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
    }
  }
}

.block {
  width: 148px;
  // height: 299px;
  background: #242121;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  position: absolute;
  top: 3rem;
  right: 15px;
  padding: 15px 15px 0 15px;

  div {
    text-align: center;
    margin-bottom: 15px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
}

.user-scroll {
  height: calc(var(--height) - 6.25rem);
  overflow-y: scroll;

  .lucky-item-match {
    padding: 0 0.9375rem;
  }
}

.my-swipe .van-swipe-item {
  height: 150px;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
}

.TokenPocket {
  height: 213px;
  padding: 0 15px;

  div {
    width: 158px;
    height: 45px;
    float: left;
    margin-bottom: 15px;
  }

  div:nth-child(2n) {
    width: 158px;
    height: 45px;
    float: right;
  }

  img {
    width: 158px;
    height: 45px;
  }
}

.friend {
  margin: 10px 15px 15px;

  span {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

.problem-div {
  border: 1px solid;
  display: flex;
  justify-content: space-between;
  background: #161414;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  margin: 0 15px;
  padding: 15px 24px 15px;
  margin-bottom: 15px;

  .number {
    text-align: center;
    width: 26px;
    height: 26px;
    margin-right: 15px;
    margin-top: 16px;
    position: relative;

    img {
      width: 26px;
      height: 26px;
    }

    span {
      position: absolute;
      top: 4px;
      margin: auto;
      bottom: 0;
      left: 0;
      right: 0;
      font-size: 11px;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }

  div:nth-child(2) {
    width: 100%;

    .problem-span {
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }

    .problem-answer {
      font-size: 12px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
    }
  }
}

.problem {
  padding: 15px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;

  div:nth-child(1) {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  div:nth-child(2) {
    span {
      font-size: 12px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      position: relative;
      top: -2px;
    }

    img {
      width: 13px;
      height: 13px;
    }
  }
}

::-webkit-scrollbar {
  display: none;
}

.padding-two {
  padding: 0 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .big {
    text-align: center;
    width: 48%;
    margin-top: 25px;
    height: 100px;
    border-radius: 5px 5px 5px 5px;
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    div:nth-child(1) {
      width: 56px;
      height: 16px;
      font-size: 14px;
      font-family: FZLanTingHei-B-GBK-Regular, FZLanTingHei-B-GBK;
      font-weight: 400;
      color: #ffffff;
      white-space: nowrap;
      padding: 19px 0 20px 16px;
      overflow: hidden;

      >p {
        display: block;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 2px;
      }
    }

    div:nth-child(2) {
      padding-left: 16px;
      display: flex;

      >p {
        display: block;
        padding: 4px 10px;
        background: #ffffff;
        border-radius: 18px;
        font-size: 0.75rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #161414;
      }
    }
  }
}

.big-back1 {
  background-image: url('../assets/300.png');
}

.big-back2 {
  background-image: url('../assets/301.png');
}

.big-back3 {
  background-image: url('../assets/303.png');
}

.big-back4 {
  background-image: url('../assets/304.png');
}

.big-back5 {
  background-image: url('../assets/305.png');
}

.index-view {
  width: 100vw;
  height: var(--height);
  background: #000000;

  .padding {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .no-left {
      margin-left: 0 !important;
    }

    .big {
      text-align: center;
      width: 48%;
      margin-top: 25px;
      height: 100px;
      border-radius: 5px 5px 5px 5px;
      background-position: center center;
      background-size: 100% 100%;
      background-repeat: no-repeat;

      div:nth-child(1) {
        width: 56px;
        height: 16px;
        font-size: 14px;
        font-family: FZLanTingHei-B-GBK-Regular, FZLanTingHei-B-GBK;
        font-weight: 400;
        color: #ffffff;
        white-space: nowrap;
        padding: 19px 0 20px 16px;
        overflow: hidden;

        >p {
          display: block;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 2px;
        }
      }

      div:nth-child(2) {
        padding-left: 16px;
        display: flex;

        >p {
          display: block;
          padding: 4px 10px;
          background: #ffffff;
          border-radius: 18px;
          font-size: 0.75rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #161414;
        }
      }
    }
  }

  .division {
    display: flex;
    align-items: center;
    padding: 0 0.9375rem;
    height: 3.5rem;

    >div:nth-child(1) {
      width: 30%;
      height: 2px;
      background: linear-gradient(270deg, rgba(255, 255, 255, 0.28) 0%, rgba(128, 128, 128, 0) 100%);
    }

    >div:nth-child(2) {
      width: 40%;
      font-size: 0.8125rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      min-width: 3rem;
      text-align: center;
    }

    >div:nth-child(3) {
      width: 30%;
      height: 2px;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0.28) 0%, rgba(128, 128, 128, 0) 100%);
    }
  }

  .lucky {
    // height: 39px;
    display: flex;
    justify-content: space-around;
    padding-top: 17px;

    div {
      width: auto;
      height: 23px;
    }

    .click-div {
      span {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #f8c007;
      }

      width: auto;
      border-bottom: 1px solid #f8c007;
      height: 23px;
    }

    span {
      width: 80px;
      height: 23px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
    }
  }

  .exchange {
    // width: 345px;
    // height: 64px;
    background: #110E31;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    margin: 0 15px;
    padding: 15px;
    display: flex;
    justify-content: space-between;

    .exchange-div {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .span {
        // width: 40px;
        // overflow: hidden;
        // text-align: center;
        // text-overflow: ellipsis;
      }

      div {
        text-align: center;
        // flex: 1;

        >img {
          width: 40px;
          height: 40px;
        }

        span {
          font-size: 13px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }

    .money_x {
      width: 10%;
      min-width: 5rem;
      max-width: 5rem;

      >div:nth-child(1) {
        font-size: 13px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 0.625rem;
      }

      >div:nth-child(2) {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-top: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 0.625rem;
      }

      >div:nth-child(3) {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 0.625rem;
      }
    }
  }

  .advertisement {
    // height: 46px;
    // border: 1px solid #FFF7CC;
    margin: 15px;
  }

  .banner {
    // width: 345px;
    height: 9.375rem;
    border-radius: 0.625rem;
    margin: 0 0.9375rem;
    overflow: hidden;
  }

  .money {
    // border: 1px solid #FFFFFF;
    display: flex;
    justify-content: flex-end;
    height: 3.125rem;
    padding: 0 0.9375rem;
    align-items: center;
    margin-left: auto;

    >div:nth-child(1) {
      min-width: 4rem;
      border-radius: 15px;
      border: 1px solid #f8c007;
      padding: 0.5rem 0.625rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;

      >p {
        font-size: 0.75rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #f8c007;
        text-align: center;
      }
    }

    div:nth-child(2) {
      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .index-view-top {
    height: 3.125rem;
    display: flex;
    align-items: center;
    padding: 0 0.9375rem;

    .logo {
      >img {
        display: block;
        width: 61.5px;
        height: 38px;
      }
    }

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #c08d4e;
      padding-left: 0.625rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/luckyhash/luckyhash.vue